import script from "./FAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=337946a0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2842137582/src/pineridgefarmsapartments/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337946a0"]])

export default __exports__